<template>
  <div class="indexBox">
    <div class="bigImg">
      <swiper v-if="swiperData" ref="mySwiper" :options="swiperOption">
        <div class="swiper-slide" v-for="(item, i) in swiperData" :key="i" @click="jumpClick(item.url)">
          <img :src="item.imgUrl" />
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div v-if="imgData">
        <img @click="jumpClick(imgData.url)" :src="imgData.imgUrl !== '' ? imgData.imgUrl : ''" alt="">
      </div>
   
      <div class="top-box" v-if="!hideDate">

        <div class="top-flex">
          <div class="left">
            <div>伦敦金</div>

            <div>
              <span>{{ priceRange.value }}</span>

              <span :class="priceRange.value > 0 ? 'slider' : 'slider1'">{{ priceRange.symbol }} {{ priceRange.percentage
                }}</span>
            </div>
          </div>

          <div :class="priceRange.value > 0 ? 'right' : 'right rights'">{{ priceRange.value > 0 ? golds + '↑' : golds + '↓' }}</div>
        </div>
        <div class="top-flex">
          <div class="left">
            <div>伦敦银</div>
            <div>
              <span>{{ priceRange1.value }}</span>
              <span :class="priceRange1.value > 0 ? 'slider' : 'slider1'">{{ priceRange1.symbol }} {{ priceRange1.percentage
                }}</span>
            </div>
          </div>
          <div :class="priceRange1.value > 0 ? 'right' : 'right rights'">{{ priceRange1.value > 0 ? sliver + '↑' : sliver + '↓' }}
          </div>
        </div>
        <div class="top-flex">
          <div class="left">
            <div>美国原油 <span class="refer">(参考)</span></div>
            <div>
              <span>{{ priceRange2.value }}</span>
              <span :class="priceRange2.value > 0 ? 'slider' : 'slider1'">{{ priceRange2.symbol }} {{ priceRange2.percentage
                }}</span>
            </div>
          </div>
          <div :class="priceRange2.value > 0 ? 'right' : 'right rights'">{{ priceRange2.value > 0 ? usd + '↑' : usd + '↓' }}</div>
        </div>
        <div class="top-flex">
          <div class="left">
            <div>纳斯达克指数<span class="refer">(参考)</span></div>
            <div>
              <span>{{ priceRange3.value }}</span>
              <span :class="priceRange3.value > 0 ? 'slider' : 'slider1'">{{ priceRange3.symbol }} {{ priceRange3.percentage
                }}</span>
            </div>
          </div>
          <div :class="priceRange3.value > 0 ? 'right' : 'right rights'">{{ priceRange3.value > 0 ? nas + '↑' : nas + '↓' }}</div>
        </div>
        <div class="top-flex">
          <div class="left">
            <div>恒生指数<span class="refer">(参考)</span></div>
            <div>
              <span>{{ priceRange4.value }}</span>
              <span :class="priceRange4.value > 0 ? 'slider' : 'slider1'">{{ priceRange4.symbol }} {{ priceRange4.percentage
                }}</span>
            </div>
          </div>
          <div :class="priceRange4.value > 0 ? 'right' : 'right rights'">{{ priceRange4.value > 0 ? hk50 + '↑' : hk50 + '↓' }}</div>
        </div>
      </div>
    </div>
    <div class="part1" v-if="!hideDate">
      <div class="contens">
        <div class="indexTitle1"><span>实时</span>数据分析</div>
        <div class="titles">洞悉市场脉动，掌握交易先机</div>
        <div class="selectCont">
          <div :class="selectIndex == 1 ? 'select cont1' : 'cont1'" @click="btnChange">
            <img src="../../static/index/iconimg.png" alt="">
            <div>
              <span>伦敦金</span>
              <span>{{ golds }} USD <span class="gols">{{ priceRange.value }}</span> <span class="gols"
                  style="margin-left: 10px">{{ priceRange.symbol }}<span>{{ priceRange.percentage
                    }}</span></span></span>
            </div>
          </div>
          <div :class="selectIndex == 2 ? 'select cont2' : 'cont2'" @click="btnChange1">
            <img src="../../static/index/iconimg1.png" alt="">
            <div>
              <span>伦敦银</span>
              <span>{{ sliver }} USD <span class="gols">{{ priceRange1.value }}</span> <span class="gols"
                  style="margin-left: 10px">{{ priceRange1.symbol }}<span>{{ priceRange1.percentage
                    }}</span></span></span>
            </div>
          </div>
        </div>
        <div id="echartsBox_one" style="background-color:#fff" class="echartsBoxItem"></div>
        <div class="part1-select">
          <div class="timelist">
            <div @click="selectTime(index)" v-for="(item, index) in timelist" :key="index"
              :class="selectIndex1 == index ? 'selcts part1-felx1' : 'part1-felx1'">
              {{ item }}
            </div>
          </div>
          <div class="part1-felx">
            <div class="part1-box part1-felx1">
              <img @click="changeTypes1" src="../../static/index/part.png" :class="changeType == 1 ? 'changes mgs' : 'mgs'"
                alt="">
              <!-- k线图 -->
              <img @click="changeTypes" :class="changeType == 2 ? 'changes' : ''" src="../../static/index/line.png" alt="">
            </div>
            <div class="part1-boxs part1-felx1" @click="showAll">
              <img src="../../static/index/jiaohu/all.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part2" ref="targetElement" style="margin-top: 20px;">

      <div class="part2-left" >
        <img v-if="showAndroid" @click="androidDownload" src="../../static/index/androld.png" class="download" alt="" />
        <img v-if="showAndroid" @click="iosDownload" src="../../static/index/ios.png" class="download ios" alt="" />
        <div v-if="showAndroid">扫码下载</div>
        <div class="names" v-if="showAndroid">{{appName}}APP</div>
        <div class="codeBoxs" v-if="showAndroid">
          <canvas class="canvasCode" ref="qrcodeCanvas"></canvas>

        </div>
      </div>
      <img class="phone" src="../../static/index/phone.png" alt="" />
      <div class="part2-right">
        <div class="indexTitle1"><span>下载</span>红狮APP</div>
        <div class="contents">
          多功能一站式平台，为您提供伦敦金、伦敦银等品种的开户、交易、出入金、产品报价、行情资讯、财经新闻、专家解盘、24h客服团队等服务，让您不惧时间和空间限制，随时随地使用手机进行交易。
        </div>
        <div class="right-bott">
          <div>
            <img src="../../static/index/Desktop.png" alt="" />
            <span>顶尖技术团队倾力打造</span>
          </div>
          <div>
            <img src="../../static/index/Update.png" alt="" />
            <span>2000+日夜精心打磨APP细节</span>
          </div>
          <div>
            <img src="../../static/index/User Group.png" alt="" />
            <span>200+万用户使用</span>
          </div>
          <div>
            <img src="../../static/index/Earth.png" alt="" />
            <span>权威平台认可</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part3">
      <div class="indexTitle1">专注黄金交易 <span>一站式</span>管家服务</div>
      <div class="titles">金牌管家，财富之路领航者</div>
      <serveBox></serveBox>
    </div>
    <div class="part4">
      <div class="part4-left">
        <div class="indexTitle1"><span>轻松黄金交易</span>品鉴愉悦人生</div>
        <div class="part4-title">
          <span>稳值增值</span>（时光流转 价值永存）
        </div>
        <div class="part4-titles">
          从古代起黄金便已开始被当作货币来交易，流传千年经久不衰，他的价值不论国界不分币种，
          是全世界公认保值性极高的贵金属。
        </div>
        <div class="part4-title">
          <span>双向机制</span>（进退自如 无惧牛熊）
        </div>
        <div class="part4-titles">
          黄金是可以双向交易的产品，既可以做多也可以做空，选对行情两边皆是机会。因此在国际金融环境毕竟动荡的今天，选择黄金能对冲很多风险。
        </div>
        <div class="part4-title">
          <span>市场透明</span>（信息对称 交易公正）
        </div>
        <div class="part4-titles">
          全球有8大黄金市场，尽管分布极为广泛，却是全球统一透明的价格，全球交易拥有通行的规则和价格，是可以所见即所得的放心产品。
        </div>
        <div class="part4-title">
          <span>交易灵活</span>（随时随地 皆可操作）
        </div>
        <div class="part4-titles">
          黄金拥有24小时交易时间，支持智能挂单，智能止盈止损，是可以实现随时随地，随心交易，即使离线，也能精准执行操作。
        </div>
      </div>
      <div class="part4-right">
        <img src="../../static/index/phones.png" alt="" />
      </div>
    </div>



    <div class="Float" v-if="false" @click="jumpActivity">
      <img @click.stop="
        () => {
          controlFloat = false;
        }
      " src="../../static/index/closer2.png" alt="" />
      <div class="floatBox" v-if="openFloat">
        <ul class="codeBox">
          <li>
            <img src="../../static/index/iosCode.png" alt="" />
            <span>App Store</span>
          </li>
          <li>
            <img src="../../static/index/androidcode.png?v=2" alt="" />
            <span>Android</span>

          </li>
        </ul>
      </div>
    </div>

  </div>
</template>
<script>
import { base64ToFloat32 } from "../../utils/tools";
import { analyticalData } from "../../utils/tools";
import { quote, quoteTime } from "../../api/info";
import { maidian } from "../global";
import { getChannelInfo, getConfigurationValue } from "@/apis/common";

import { generateQRCode } from "../../utils/tools";
import eventBusMitter from '../../utils/eventbus'
import { EleResize } from '../../utils/esresize'// 图表自适应
import * as echarts from 'echarts';
import { mapState } from "vuex";
import { param } from "jquery";
import { queryBrandImgList } from '../apis/common';
import { getActiveDomain } from '../../utils/IMEI';
import serveBox from '../components/serveBox/indnex.vue'
export default {
  name: "Index",
  metaInfo: {
    title: '红狮金业官网,15年贵金属交易平台,黄金交易平台',
    meta: [
      {
        name: "keywords",
        content:
          "红狮金业,红狮启富,黄金交易平台,贵金属交易,贵金属投资,贵金属平台,现货黄金开户,正规靠谱外汇交易,正规网上交易平台",
      },
      {
        name: "description",
        content:
          "红狮金业是专业值得信赖的国际投资交易平台,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。",
      },
    ]
  },
  components: {
    serveBox
  },
  data() {
    return {
      screenWidth: null,
      showAndroid: true,
    }
  },
  data() {
    return {
      openFloat: false,

      controlSwiper: true,
      // swiper 参数
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        preventClicks: true,
        //自动播放
        autoplay: {
          delay: 3000, //延迟播放下一张图片
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,

        },
      },
     
      London: {
        gold: "--",
        silver: "--",
        goldRise: "0.0",
        silverRise: "0.0",
        goldPer: "0.00%",
        silverPer: "0.00%",
        controlPic: true,
        controlPicOther: true,
      },
      goldCl: "",
      silverCl: "",
      ahref:
        "https://www.rlcltd001.com/#/subject/worldCup/index?craig=" +
        window.location.origin,
      controlFloat: true,
      controlDark: true,
      swiperData: "",
      imgData: "",
      screenWidth: null,
      selectIndex: 1,
      types: '',
      timelist: ['1天', '1个月', '3个月', '1年'],//时间数组
      selectIndex1: '0',//时间的选择
      changeType: '1',//图表类型
      sbldata: {

      },
      highLowData: {},
      symbols: '伦敦金',
      hideDate: false,
      appName:'红狮乐富',
      showAndroid: true,
    };
  },
  created() {

    const Rhref = window.location.host;

    if (Rhref.indexOf('hspluspro') > -1) {
      this.appName = '乐富智享'
    }
    if (Rhref.indexOf('rlctop') > -1) {
      this.showAndroid = false
    }
    setTimeout(() => {
      eventBusMitter.emit('eventBus1', { key: 0 })
      eventBusMitter.emit('eventtab', { key: true })
      this.initCharts()
    }, 500); // 秒后关闭弹窗
    // 自动切换serveBox
    setInterval(this.updateDiv, 4000);
    // 传参控制显示顶部和底部
    this.$emit("controlShow", false);
    // crm数据埋点
    maidian(
      { eventname: "z1", eventdescribe: "访客数据", eventtype: "visit" },
      undefined,
      { toPath: "www.123.com", fromPath: "www.baidu.com" },
      "indexMaidian"
    );
    this.initSwiper();
    const channel = sessionStorage.getItem('channel');
    this.getAndroidUrl(channel);
    this.getIosUrl()

  },
  mounted() {


    const { origin } = window.location;
    
    const channel = this.appName == '乐富智享' ? '9947' : sessionStorage.getItem('channel');

    const Rhref = window.location.host;

    if (Rhref.indexOf('rlchltd') > -1) {

      var url = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'

    } else {
      var url = origin + '/subject/download?channel=' + channel

    }
    // 去掉实时数据https://sem.hspluspro.com/ 
    if (Rhref.indexOf('hspluspro') > -1 || Rhref.indexOf('hsrlcool') > -1 || Rhref.indexOf('sem.hslefu') > -1||Rhref.indexOf('sem.hshjlexiang') > -1) {
      this.hideDate = true

    } else {
      this.hideDate = false

    }

    const icon = require('../../static/index/hongshi.jpg')

    generateQRCode(url, this.$refs.qrcodeCanvas, icon)
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;

      })()
    };


    this.initCharts()


    // this.partical();
    setTimeout(() => {
      this.controlDark = false;
    }, 5000); // 4 秒后关闭弹窗

    window.addEventListener("scroll", this.handleScroll);



  },
  methods: {
    //获取Android下载链接
    async getAndroidUrl(code) {
      const Rhref = window.location.host;

      if (Rhref.indexOf('rlchltd') > -1) {
        this.androidUrl = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'
      } else {
        const res = await getChannelInfo(code)
        const { downloadUrl } = res;
        this.APKurl = downloadUrl || '';
        const { origin } = window.location;
        const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
        if (absoluteURLRegex.test(downloadUrl)) {
          this.androidUrl = downloadUrl
        } else {
          this.androidUrl = origin + '/' + downloadUrl
        }
      }

    },
    //获取ios下载链接
    async getIosUrl() {
      const res = await getConfigurationValue({ key: 'H5URLBeforeA' })
      if (res) {
        this.iosUrl = await getActiveDomain(res)
      }
    },
    iosDownload() {
      // window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
      window.location.href = this.iosUrl;
    },
    androidDownload() {
      window.location.href = this.androidUrl;
    },
    // 获取swiper接口
    initSwiper() {

      const params = {
        languageIdentification: '1',
        type: '58',
        brandId: '1',
        region: '1',
      }
      queryBrandImgList(params).then((res) => {
        if (res && res.length > 0) {
          this.swiperData = res;

        } else {
          this.imgData = res[0];


        }
        if (this.swiperData.length < 2) {
          this.swiperOption.loop = false;
        }
      }).catch(err => {
        console.log(err);
      })

    },
    downLoadIos() {
      // window.location.href = 'https://apps.apple.com/cn/app/%E5%AE%89%E8%83%9C%E8%B4%A2%E5%AF%8C/id1602800589';
      window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
    },
    downLoadAndroid() {
      // window.location.href = 'https://oss.0790jiaxiao.com/HS/software/hs_9999.apk';
      window.location.href = 'https://oss.0790jiaxiao.com/hsnew/apk/2.9.2/red_lionRelease-V2.9.2_9999.apk';
    },
    // 切换为K线图
    changeTypes() {

      this.changeType = 2
      this.initCharts1()
    },
    changeTypes1() {

      this.changeType = 1
      this.initCharts()
    },
    // 选择时间
    selectTime(e) {

      this.selectIndex1 = e
      eventBusMitter.emit('eventBus1', { key: e })
      if (this.changeType == 1) {
        this.initCharts()

      } else {
        this.initCharts1()
      }
    },
    // 切换图表数据伦敦银
    btnChange() {
      this.selectIndex = 1
      eventBusMitter.emit('eventBus', { key: 'GOLD' })
      if (this.changeType == 1) {
        this.initCharts()

      } else {
        this.initCharts1()
      }

    },
    // 伦敦金
    btnChange1() {
      this.selectIndex = 2
      eventBusMitter.emit('eventBus', { key: 'SILVER' })
      if (this.changeType == 1) {
        this.initCharts()

      } else {
        this.initCharts1()
      }
    },
    // 全屏展示数据
    showAll() {
      const element = document.getElementById('echartsBox_one')
      // 一些浏览器的兼容性
      if (element.requestFullScreen) {
        // HTML W3C 提议
        element.requestFullScreen()
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullScreen()
      } else if (element.webkitRequestFullScreen) {
        // Webkit (works in Safari5.1 and Chrome 15)
        element.webkitRequestFullScreen()
      } else if (element.mozRequestFullScreen) {
        // Firefox (works in nightly)
        element.mozRequestFullScreen()
      }

      // 退出全屏
      if (element.requestFullScreen) {
        document.exitFullscreen()
      } else if (element.msRequestFullScreen) {
        document.msExitFullscreen()
      } else if (element.webkitRequestFullScreen) {
        document.webkitCancelFullScreen()
      } else if (element.mozRequestFullScreen) {
        document.mozCancelFullScreen()
      }
    },
    
    // 获取echart数据
    initCharts() {

      var chartDom = document.getElementById("echartsBox_one");

      var myChart = echarts.init(chartDom);
      var listener = function () {
        myChart.resize()
      }
      EleResize.on(chartDom, listener)
      let dataArr = this.dataArr

      let date = [];
      let data = [];
      let data1 = []
      if (dataArr && dataArr.length > 0) {
        dataArr.map(item => {
          if (this.selectIndex1 == 1 || this.selectIndex1 == 2) {
            data.push(item[1])
            date.push(item[0])
            data1.push({ name: item[1], value: this.timestampToTime(item[6] * 1000) })

          } else {
            data.push(item[1])
            date.push(item[0])
          }



        })
      }
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: params => {

            const data = params[0];

            let title = ''


            if (data1.length > 0) {
              data1.forEach(item => {
                if (item.name == params[0].data) {
                  title = ' ' + ' ' + item.value
                }
              })
            } else if (data1.length == 0) {
              title = ''
            }

            return `${data.name}${title} <br>${data.marker} ${data.data}  `;
          }
        },
        title: {
          left: 'center',
          text: ''
        },
        toolbox: {
          top: "95%",


          feature: {



          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,


          data: date
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          position: 'right',
          scale: true,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 200
          },
          {
            start: 0,
            end: 200
          }
        ],


        series: [
          {
            name: this.selectIndex == 1 ? '伦敦金' : '伦敦银',
            type: 'line',
            symbol: 'none',
            smooth: true,
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: data
          }
        ]
      };

      myChart.setOption(option);
    },

    //k线图
    initCharts1() {
      var chartDom = document.getElementById("echartsBox_one");
      var myChart = echarts.init(chartDom);
      let dataArr = this.dataArr
      let date = [];
      let data = [];
      let data1 = []
      if (dataArr && dataArr.length > 0) {
        dataArr.map(item => {


          if (this.selectIndex1 == 1 || this.selectIndex1 == 2) {
            data1.push([item[1], item[2], item[3], item[4], this.timestampToTime(item[6] * 1000), item[0]])
            data.push([item[1], item[2], item[3], item[4]])
            date.push(item[0])

          } else {
            data.push([item[1], item[2], item[3], item[4]])
            date.push(item[0])
          }

        })
      }


      let xAxisDataSet = new Set();
      let xAxisDateIndex = 0;
      let dats = [];
      let option = {

        tooltip: {
          trigger: 'axis',
          formatter: params => {

            const data = params[0];

            let title = '开：' + data.data[1]
            let title1 = '高：' + data.data[3]
            let title2 = '低：' + data.data[4]
            let title3 = '收：' + data.data[2]
            let titles = ''

            if (data1.length > 0) {
              data1.forEach(item => {
                if (item[0] == params[0].data[1]) {
                  titles = ' ' + ' ' + item[4]
                }
              })
            } else if (data1.length == 0) {
              titles = ''
            }

            return `${data.name}${titles} <br>${data.marker}  \u00A0${title}<br>${data.marker}  \u00A0${title1}<br>${data.marker} \u00A0${title2}<br>${data.marker}  \u00A0${title3} `;
          }

        },
        xAxis: {
          type: 'category',
          data: date,
          axisTick: {
            alignWithLabel: true, // true：标签位于刻度线正下方；false：标签位于2个刻度线中间
          },
          axisLabel: {
            formatter: (value, index) => {

              if (this.selectIndex1 == 1 || this.selectIndex1 == 2) {
                if (index < xAxisDateIndex) {
                  xAxisDataSet.clear();
                }
                xAxisDateIndex = index;
                let date = value
                const d = xAxisDataSet.has(date);
                if (!d) {
                  xAxisDataSet.add(date);
                  return date;
                }
                return '';
              }
              else {
                return value
              }
            }
          },
          axisLine: { lineStyle: { color: '#8392A5' } }
        },
        yAxis: {
          scale: true,
          axisLine: { lineStyle: { color: '#8392A5' } },
          splitLine: { show: false },
          position: 'right',
        },
        grid: {
          bottom: 80
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0, 1],
            start: 190,
            end: 200
          },
          {
            show: true,
            xAxisIndex: [0, 1],
            type: 'slider',
            bottom: 20,
            start: 190,
            end: 200
          }
        ],
        series: [
          {
            type: 'candlestick',
            name: this.selectIndex == 1 ? '伦敦金' : '伦敦银',
            data: data,
            itemStyle: {
              color: '#FD1050',
              color0: '#0CF49B',
              borderColor: '#FD1050',
              borderColor0: '#0CF49B'
            }
          },

        ]
      };

      myChart.setOption(option);

    },
    partical() {
      var canvas = document.getElementById("canvasParticle");
      const W = window.innerWidth;
      const H = 1000; // window.innerHeight
      var ctx = null;
      canvas.setAttribute("width", W);
      canvas.setAttribute("height", H);
      ctx = canvas.getContext("2d");
      const config = {
        number: 30, // 生成的粒子数量
        snowArr: [],
        pic: this.pic,
      };
      for (let i = 0; i < config.number; i++) {
        config.snowArr.push({
          x: Math.random() * W, // 定义每片粒子的X轴
          y: Math.random() * H, // Y轴
          toX: Math.random() * 1 + 3, // 粒子每一次渲染的X距离
          toY: Math.random() * 1 + 3,
          size: Math.random() * 100 + 5, // 粒子的大小
        });
      }
      const dropAnimation = () => {
        ctx.clearRect(0, 0, W, H); // 清除画布重新渲染
        let j = 0;
        for (let i = 0; i < config.snowArr.length; i++) {
          const snow = config.snowArr[i];
          const snowImg = new Image();
          if (j > 24) {
            j = 0;
          }
          snowImg.src = config.pic[j];
          ctx.drawImage(snowImg, snow.x, snow.y, snow.size, snow.size);
          snow.x = snow.x > W ? 0 : snow.x + snow.toX; // 每调一次函数向右移动一点
          snow.y = snow.y > H ? 0 : snow.y + snow.toY; // 向下移动
          j++;
        }
        requestAnimationFrame(dropAnimation);
      };
      requestAnimationFrame(dropAnimation);
    },


    initRealtime(attr) {
      quoteTime(attr).then((res) => {
        this.London.gold = res.dt.list[0].bid;
        this.London.silver = res.dt.list[1].bid;
        // 黄金 实时与昨收比较大小 决定显示图片
        if (Number(this.goldCl) < Number(this.London.gold)) {
          this.London.controlPic = true;
        } else {
          this.London.controlPic = false;
        }
        // 白银 实时与昨收比较大小 决定显示图片
        if (Number(this.silverCl) < Number(this.London.silver)) {
          this.London.controlPicOther = true;
        } else {
          this.London.controlPicOther = false;
        }
        // 黄金 计算涨幅;
        this.London.goldRise = (
          Number(this.London.gold) - Number(this.goldCl)
        ).toFixed(2);
        // 计算百分比（涨幅/昨收）
        this.London.goldPer =
          ((this.London.goldRise / this.goldCl) * 100).toFixed(2) + "%";
        // 白银 涨幅
        this.London.silverRise = (
          Number(this.London.silver) - Number(this.silverCl)
        ).toFixed(3);
        // 计算百分比（涨幅/昨收）
        this.London.silverPer =
          ((this.London.silverRise / this.silverCl) * 100).toFixed(2) + "%";
      });
    },
    handleScroll() {
      //改变元素#searchBar的top值


    },
    // 切换serveBox的方法
    updateDiv() {
      if (this.controlDiv < 5) {
        this.controlDiv = this.controlDiv + 1;
      } else {
        this.controlDiv = 1;
      }
    },



    jumpClick(attr) {
      window.open(attr);
    },
    jumpActivity() {
      //window.open('https://www.rlcvipltd.net/uc/signUp/real');
      this.openFloat = true;
    },

    timestampToTime(timestamp) {
      let date = new Date(parseInt(timestamp));
      let Year = date.getFullYear();
      let Moth =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let Day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let Hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let Minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let Sechond =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Hour + ":" + '00';
    },
    timestampToTime(data) {
      var time;
      var hours = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (data % (1000 * 60)) / 1000;
      time = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
      return hours + ':' + '00';
    }
  },

  watch: {
    screenWidth(n) {
      if (n <= 500) {
        this.$router.push({
          name: "wapIndex",
        });
      }
    },

    // 选择数据图表数据
    dataArr(newVal) {
      if (newVal && this.changeType == 1) {
        this.initCharts()
      } else {
        this.initCharts1()
      }
    },



  },
  computed: {
    dataArr() {
      return this.$parent.dataArr
    },
    golds() {
      return this.$parent.goldData
    },
    high() {
      return this.$parent.goldData1
    },

    priceRange() {
      let value = (this.golds - this.high).toFixed(2)
      let symbol = value > 0 ? '+' : '-'
      let percentage = this.high ? ((Math.abs(value) * 100) / this.high).toFixed(2) + '%' : '0.00%';
      return { value, symbol, percentage }
    },
    hk50() {

      return this.$parent.hk50
    },
    hk501() {
      return this.$parent.hk501
    },

    priceRange4() {
      let value = (this.hk50 - this.hk501).toFixed(2)
      let symbol = value > 0 ? '+' : '-'
      let percentage = this.hk501 ? ((Math.abs(value) * 100) / this.hk501).toFixed(2) + '%' : '0.00%';
      return { value, symbol, percentage }
    },
    nas() {
      return this.$parent.nas
    },
    nas1() {
      return this.$parent.nas1
    },

    priceRange3() {
      // console.log(this.nas,this.nas1)
      let value = (this.nas - this.nas1).toFixed(2)
      let symbol = value > 0 ? '+' : '-'
      let percentage = this.nas1 ? ((Math.abs(value) * 100) / this.nas1).toFixed(2) + '%' : '0.00%';
      return { value, symbol, percentage }
    },
    sliver() {
      return this.$parent.sliver
    },
    sliver1() {
      return this.$parent.sliver1
    },

    priceRange1() {
      let value = (this.sliver - this.sliver1).toFixed(2)
      let symbol = value > 0 ? '+' : '-'
      let percentage = this.sliver1 ? ((Math.abs(value) * 100) / this.sliver1).toFixed(2) + '%' : '0.00%';
      return { value, symbol, percentage }
    },
    usd() {
      return this.$parent.usd
    },
    usd1() {
      return this.$parent.usd1
    },

    priceRange2() {
      // console.log(this.usd,this.usd1)

      let value = (this.usd - this.usd1).toFixed(2)
      let symbol = value > 0 ? '+' : '-'
      let percentage = this.usd1 ? ((Math.abs(value) * 100) / this.usd1).toFixed(2) + '%' : '0.00%';
      return { value, symbol, percentage }
    },
  }
};
</script>

<style lang="less" scoped>
.indexBox {
  width: 100%;

  .bigImg {
    width: 100%;
    height: 810px;

    // background: url("../../static/index/topbg.png") no-repeat,

    //   linear-gradient(100.69deg,
    //     rgba(0, 0, 0, 0.6) 27.87%,
    //     rgba(10, 10, 10, 0) 72.52%,
    //     rgba(10, 10, 10, 0.2) 100%);

    // mix-blend-mode: multiply; /* 使用multiply混合模式 */
    // background-color: black;
    /* 叠加的颜色 */
    background-size: 100% 100%;

    // padding-left: 15%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;

    .topbg {
      width: 100%;
      height: 810px;
    }

    .top-left {
      display: flex;
      flex-direction: column;

      // align-items: center;
      .top-title {
        color: #fff;
        font-size: 80px;
        font-weight: 700;
        line-height: 106px;
        margin: 34px 0 26px 0;
      }

      .top-img {
        width: 139px;
        height: 38px;
      }

      .top-imgs {
        margin: 66px 0 110px 0;
        width: 198px;
        height: 56px;
        cursor: pointer;
      }

      .top-titles {
        color: #fff;
        font-size: 26px;

        line-height: 34px;
      }
    }

    .top-flex {
      display: flex;
      align-items: center;
    }

    .refer {
      font-size: 10px;
      line-height: 14px;
      color: #FA2314;
    }

    .top-line {
      width: 1px;
      height: 60px;
      margin: 0 32px;
      background: #fff;
    }

    .top-bottoms {
      display: flex;
      align-items: center;

      div {
        display: flex;
        // align-items: center;
        flex-direction: column;
        color: #fff;
        font-size: 16px;
        line-height: 26px;
        margin-left: 12px;
      }
    }

    .top-right {
      img {
        width: 750px;
        height: 822px;
        margin-top: 103px;
      }
    }

    .top-box {
      width: 1320px;
      height: 100px;
      padding: 26px 38px;
      box-sizing: border-box;
      background: #fff;
      position: absolute;
      bottom: -6%;
      left: 15%;
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 0px 40px 0px #0000000f;

      div {
        .left div:nth-child(1) {
          line-height: 21px;
          font-size: 16px;
          color: #000;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .left div:nth-child(2) {
          span {
            font-size: 14px;
            line-height: 19px;
            color: #11c771;
          }
        }
      }

      .slider {
        color: #fa2314;
        margin-left: 17px;
      }

      .slider1 {
        margin-left: 17px;

      }

      .right {
        width: 96px;
        height: 40px;
        background: #fa2314;
        font-size: 16px;
        line-height: 21px;
        font-weight: 700;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 24px;
      }

      .rights {
        background: #11c771;

      }
    }

    /deep/ .swiper-container {
      .swiper-slide {

        width: 100%;
        border: none;
        img {
          width: 100%;
          height: 810px;
          cursor: pointer;
          // object-fit: cover;
        }
      }

      .swiper-pagination {
        .swiper-pagination-bullet-active {
          background-color: #e1352a;

        }
      }
    }
  }

  .part1 {
    width: 100%;
    background: #fff;
    padding: 130px 0px 169px;
    position: relative;

    .titles {
      font-size: 18px;
      line-height: 24px;
      text-align: left;
      margin-top: 18px;
    }

    .contens {
      margin-left: 15%;

      .echartsBoxItem {
        width: 1320px;
        height: 328px;

      }
    }

    .part1-select {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 15%;
      cursor: pointer;

      .part1-box {
        width: 78px;
        height: 36px;
        border-radius: 6px;
        border: 1px solid #C9C9CF;

        img {
          width: 24px;
          height: 24px;
        }

        .changes {
          background: rgba(201, 201, 207, 0.4);

        }

        .mgs {
          margin-right: 10px;
        }

        margin-right: 16px;

      }

      .part1-boxs {
        width: 36px;
        height: 36px;
        border-radius: 6px;

        border: 1px solid #C9C9CF;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .part1-felx {
      display: flex;
      align-items: center
    }

    .part1-felx1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .timelist {
      color: #C9C9CF;
      font-size: 14px;
      line-height: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 6px;

      div {
        width: 64px;
        height: 36px;
        border-radius: 6px;
      }

      .selcts {
        color: #0F0F11;
        background: rgba(201, 201, 207, 0.4);
      }
    }

    .selectCont {
      display: flex;
      align-items: center;
      position: absolute;
      top: 20%;
      right: 15%;

      .cont1,
      .cont2 {
        cursor: pointer;
        display: flex;
        align-items: center;

        div {
          display: flex;
          flex-direction: column;
          font-size: 14px;
          line-height: 18px;
          margin-left: 12px;
        }

        div span:nth-child(1) {
          font-weight: 700;
        }
      }

      .gols {
        color: #e1352a
      }

      .cont1 {
        width: 314px;
        height: 60px;
        border-radius: 100px;
        opacity: 0.04px;
        color: #0F0F11;
        padding: 10px 18px;
        box-sizing: border-box;
        margin-right: 12px;
      }

      .cont2 {
        width: 314px;
        height: 60px;

        border-radius: 100px;
        opacity: 0.04px;
        color: #0F0F11;
        padding: 10px 18px;
        box-sizing: border-box;
      }

      .select {
        background: rgba(15, 15, 17, 0.1);
      }
    }
  }

  .part2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .codeBoxs {
      width: 140px;
      height: auto;


      img {
        width: 100%;
        height: auto;
      }

      .canvasCode {
        width: 140px !important;
        height: 140px !important;
      }

      p {
        margin: 0;
        background: #e1251a;
        box-sizing: border-box;
        padding: 10px 0;
        color: #fff;
        margin-top: -4px;
      }
    }

    .part2-left {
      margin-left: 15%;
      font-size: 16px;

      img {
        cursor: pointer
      }
    }

    .part2-right {
      margin-right: 15%;
    }

    .names {
      font-weight: 700;
    }

    .ios {
      margin: 18px 0 30px 0;
    }

    .part2-left,
    .part2-right {
      display: flex;
      flex-direction: column;
    }

    .download {
      width: 180px;
      height: 54px;
    }

    .phone {
      width: 389px;
      height: 620px;
    }

    .contents {
      margin: 18px 0 32px 0;
      width: 583px;
      height: 90px;
      font-size: 18px;
      line-height: 30px;
      text-align: left;
    }

    .right-bott {
      div {
        display: flex;
        align-items: center;
        margin-bottom: 31px;

        img {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        span {
          font-size: 18px;
        }
      }
    }
  }

  .part3 {
    margin-top: 160px;
    width: 100%;
    text-align: center;

    .indexTitle1 {
      text-align: center;
    }

    .titles {
      color: #0f0f11;
      margin: 18px 0 48px 0;
      font-size: 18px;
      line-height: 24px;
    }

    .contents {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .part4 {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 160px;

    .part4-left {
      margin-left: 15%;
      display: flex;
      flex-direction: column;

      .part4-title {
        font-size: 18px;
        line-height: 24px;
        color: #121212;
        margin-top: 22px;

        span {
          font-size: 20px;
          line-height: 26px;
          font-weight: 700;
        }
      }

      .part4-titles {
        font-size: 18px;
        width: 738px;
        height: 60px;
        color: #93939f;

        line-height: 30px;
        text-align: left;
        margin-top: 10px;
      }
    }

    .part4-right {
      img {
        // width: 737px;
        height: 516px;
      }

      margin-top: 60px;

    }
  }

  .indexTitle1 {
    font-size: 46px;
    font-weight: 700;
    line-height: 61px;
    text-align: left;
    color: #121212;

    span {
      color: #e1352a;
    }
  }

  .indexTitle {
    font-size: 28px;
    color: #121212;
    box-sizing: border-box;
    padding: 35px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: url('../../static/index/indexTitleText.png') no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }

  .craigBox {
    width: 100%;
    box-sizing: border-box;
    padding: 60px 0;
    background: url("../../static/index/changeBanner.png") no-repeat;
    background-size: cover;

    ul {
      width: 1130px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;

      li {
        width: 25%;
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        border-right: 5px solid #f8f8f8;
        padding: 80px 0 0 70px;
        position: relative;
        background-color: #fff;

        .btmBanner {
          position: absolute;
          right: 0;
          bottom: 0;
        }

        p {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          span {
            font-size: 14px;
            color: #6d6d6d;
          }

          span:nth-child(1) {
            font-size: 16px;
            font-weight: 600;
            color: #121212;
          }
        }
      }

      .wanzhengText {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end !important;
        align-items: flex-start;

        p {
          color: #fff;
          margin: 0;
          text-align: justify;
          line-height: 26px;
        }

        p:nth-child(2) {
          font-size: 22px;
          color: #fff;
          margin: 30px 0 10px;
        }
      }

      .bzBkgImg {
        background: url("../../static/index/baozhiBanner.png") no-repeat;
        background-size: cover;
        width: 45%;
      }

      .sxjzBkgImg {
        background: url("../../static/index/jiaohu/jzBanner.png") no-repeat;
        background-size: cover;
        width: 45%;
      }

      .sctmBkgImg {
        background: url("../../static/index/jiaohu/scBanner.png") no-repeat;
        background-size: cover;
        width: 45%;
      }

      .jylhkgImg {
        background: url("../../static/index/jiaohu/jyBanner.png") no-repeat;
        background-size: cover;
        width: 45%;
      }

      li .textColor span {
        color: #fff !important;
      }

      li .OpacityImg {
        display: none;
      }
    }
  }

  .serveBox {
    width: 100%;

    .sbControl {
      width: 1130px;
      height: 110px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      // border-bottom: 1px solid #e2e2e2;

      ul {
        width: 15%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        cursor: pointer;

        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 15px;
          color: #6d6d6d;
          margin-bottom: 10px;

          .svgColor {
            color: #d52226;
          }

          span {
            font-size: 18px;
            color: #121212;
            margin-top: 12px;
          }

          img {
            width: 50px;
            height: 50px;
          }
        }
      }
    }

    .sbShow {
      width: 100%;
      margin-top: 48px;

      .showChild {
        width: 100%;
        height: 442px;
        display: flex;

        align-items: center;

        img {
          width: 812px;
          height: 442px;

        }

        .showcont {
          width: 546px;
          // min-width: 950px;
          margin-left: 15%;
          height: 378px;
          padding: 48px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          background: linear-gradient(105.21deg, #fa2314 0%, #db2c23 100%);
          box-sizing: border-box;
          color: #fff;
          cursor: pointer;

          .tits {
            font-size: 32px;
            line-height: 42px;
            font-weight: 700;
          }

          .lines {
            width: 40px;
            height: 4px;
            background: #fff;
            margin: 16px 0;
          }

          .cont {
            width: 342px;
            font-size: 18px;
            line-height: 24px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .cont span:nth-child(2) {
            margin: 10px 0;
          }

          .load {
            width: 198px;
            height: 56px;
            margin-top: 64px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .Float {
    width: 230px;
    height: 360px;
    background: url("../../static/index/float.png") no-repeat;
    background-size: cover;
    position: fixed;
    top: 39%;
    right: -6%;
    transform: translate(-50%, -50%);
    z-index: 2;
    cursor: pointer;

    img {
      width: 28px;
      position: absolute;
      top: -3%;
      right: 1px;
      cursor: pointer;
    }
  }

  .dark {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      opacity: 1;
      position: relative;
      left: -50%;
    }

    .closer3 {
      width: 30px;
      position: relative;
      top: -260px;
      right: 0%;
      cursor: pointer;
    }
  }

  .lanternRight {
    width: 89px;
    position: fixed;
    top: 50%;
    right: 7%;
    z-index: 2;
    transform: translate(-50%, -50%);
  }

  .lanternleft {
    width: 89px;
    position: fixed;
    top: 50%;
    left: 10%;
    z-index: 2;
    transform: translate(-50%, -50%);
  }

}

/deep/ #box {
  margin-top: 100px;
}

// 设置swiper分页器的样式
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal>.swiper-pagination-bullets {
  bottom: 55px;
}

/deep/ .swiperOne {
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    width: 4px;
    height: 4px;
    background-color: #999999;
    border-radius: 50%;
  }

  li {
    width: 20px;
    height: 20px;
    border: 2px solid #d52226;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      width: 4px;
      height: 4px;
      background-color: #d52226;
      border-radius: 50%;
    }
  }

  .swiperOneSpan {
    margin: 0 30px;
  }
}

/deep/ .swiperTwo {
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    width: 4px;
    height: 4px;
    background-color: #999999;
    border-radius: 50%;
  }

  li {
    width: 20px;
    height: 20px;
    border: 2px solid #d52226;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 30px;

    span {
      width: 4px;
      height: 4px;
      background-color: #d52226;
      border-radius: 50%;
    }
  }
}

/deep/ .swiperThree {
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    width: 4px;
    height: 4px;
    background-color: #999999;
    border-radius: 50%;
  }

  li {
    width: 20px;
    height: 20px;
    border: 2px solid #d52226;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      width: 4px;
      height: 4px;
      background-color: #d52226;
      border-radius: 50%;
    }
  }

  .swiperThreeSpan {
    margin: 0 30px;
  }
}

.floatBox {
  position: relative;
  left: -176px;

  ul {
    width: 275px;
    position: absolute;
    top: 50px;
    left: -100px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 20px 30px 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);

    li {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      img {
        width: 100px !important;
        height: auto !important;
        position: unset !important;
        display: block;
      }

      span {
        margin-top: 5px;
        color: #000;
        line-height: 29px;
      }
    }

    li:nth-child(1) {
      margin-right: 55px;
    }
  }
}

.codeBox {
  display: flex;
}

// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .indexBox {
    .bigImg {
      height: 638px;

      .top-box {
        width: 1000px;
        height: 100px;
        padding: 13px 19px;
        box-sizing: border-box;
        background: #fff;
        position: absolute;
        bottom: -6%;
        left: 10%;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 0px 40px 0px #0000000f;

        div {
          .left div:nth-child(1) {
            line-height: 21px;
            font-size: 14px;
            color: #000;
            font-weight: 700;
            margin-bottom: 8px;
            white-space: nowrap;
          }

          .left div:nth-child(2) {
            span {
              font-size: 12px;
              line-height: 19px;
              color: #11c771;
              white-space: nowrap;
            }
          }
        }

        .slider {
          color: #fa2314;
          margin-left: 17px;
        }

        .slider1 {
          margin-left: 17px;

        }

        .right {
          width: 78px;
          height: 40px;
          background: #fa2314;
          font-size: 14px;
          line-height: 21px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 12px;
        }

        .rights {
          background: #11c771;

        }

      }

      /deep/ .swiper-container {
        .swiper-slide {

          width: 100%;

          img {
            width: 100%;
            height: 638px;
            cursor: pointer;
            // object-fit: cover;
          }
        }

        .swiper-pagination {
          .swiper-pagination-bullet-active {
            background-color: #e1352a;

          }
        }
      }
    }

    .part1 {
      .selectCont {
        position: absolute;
        top: 20%;
        right: 10%;
      }

      .contens {
        margin-left: 10%;

        .echartsBoxItem {
          width: 1000px;
          height: 328px;

        }
      }
    }

    .part2 {
      .part2-left {
        margin-left: 10%;
        font-size: 14px;
      }

      .contents {
        width: 383px;
        height: 120px;
      }

      .part2-right {
        margin-right: 10%;
      }

      .phone {
        width: 349px;
        height: 620px;
        margin: 0 60px;
      }
    }

    .part3 {}

    .part4 {
      .part4-left {
        margin-left: 10%;
        display: flex;
        flex-direction: column;

        .part4-titles {
          font-size: 18px;
          width: 468px;
          height: 70px;
          color: #93939f;

          line-height: 30px;
          text-align: left;
          margin-top: 10px;
        }
      }

      .part4-right {
        img {
          width: 637px;
          height: 516px;
          margin-top: 60px;
        }
      }
    }

    .indexTitle1 {
      font-size: 36px;
    }

    .serveBox {
      width: 100%;

      .sbControl {
        width: 1000px;
        height: 110px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        // border-bottom: 1px solid #e2e2e2;

        ul {
          width: 15%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          cursor: pointer;

          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 15px;
            color: #6d6d6d;
            margin-bottom: 10px;

            .svgColor {
              color: #d52226;
            }

            span {
              font-size: 18px;
              color: #121212;
              margin-top: 12px;
            }

            img {
              width: 50px;
              height: 50px;
            }
          }
        }
      }

      .sbShow {
        width: 100%;
        margin-top: 48px;

        .showChild {
          width: 100%;
          height: 442px;
          display: flex;

          align-items: center;

          img {
            width: 612px;
            height: 442px;

          }

          .showcont {
            width: 446px;
            // min-width: 950px;
            margin-left: 10%;
            height: 378px;
            padding: 48px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            background: linear-gradient(105.21deg, #fa2314 0%, #db2c23 100%);
            box-sizing: border-box;
            color: #fff;
            cursor: pointer;

            .tits {
              font-size: 32px;
              line-height: 42px;
              font-weight: 700;
            }

            .lines {
              width: 40px;
              height: 4px;
              background: #fff;
              margin: 16px 0;
            }

            .cont {
              width: 342px;
              font-size: 18px;
              line-height: 24px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }

            .cont span:nth-child(2) {
              margin: 10px 0;
            }

            .load {
              width: 198px;
              height: 56px;
              margin-top: 64px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>